import { render, staticRenderFns } from "./FeatureSectionCard.vue?vue&type=template&id=bc63564a&scoped=true"
import script from "./FeatureSectionCard.vue?vue&type=script&lang=js"
export * from "./FeatureSectionCard.vue?vue&type=script&lang=js"
import style0 from "./FeatureSectionCard.vue?vue&type=style&index=0&id=bc63564a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc63564a",
  null
  
)

export default component.exports